import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { closePopup, popupContentSelector } from '../../app/popup-slice'
import { buttonStyle } from '../../controls/buttons';
import { Modal, ModalContent, ModalFooter } from '../../controls/modal/modal'
import { useMessages2 } from '../../hooks/useLanguage';

export function MessageDialog() {

    const { messages } = useMessages2();
    const content = useAppSelector(popupContentSelector);
    const dispatch = useAppDispatch();

    const onClose = () => {
        dispatch(closePopup())
    }

    return <Modal onClose={onClose}>
        <ModalContent>
        {
            (content?.messages ?? []).map((m:string) => <p>{m}</p>)
        }
        </ModalContent>
        <ModalFooter>
            <button type="button" className={buttonStyle} onClick={onClose}>{ messages?.page_close_button ?? '' }</button>
        </ModalFooter>
    </Modal>
}